import React from 'react';
import { Dialog, DialogContent, DialogContentText, Slide } from '@mui/material';

const SingleSignOnModal = ({ open, sso, provider }) => {

    const Transition = React.forwardRef(function Transition(props, ref) {
        return <Slide direction="up" ref={ref} {...props} />
    });

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    Redirecting to {sso ? sso.portalDisplayName : provider}...
                </DialogContentText>
            </DialogContent>
        </Dialog>  
    );
}

export default SingleSignOnModal;